import React from 'react';
import { Order } from '@m4a3/api-client';
import { Box, Typography } from '@mui/material';

interface OrderQueueSidebarProps {
  atBaseOrders: Order[];
  notAtBaseOrders: Order[];
}

const OrderQueueCard = ({ order }: { order: any }) => {
  return (
    <Box 
      className="flex items-center bg-white border border-gray-200"
      sx={{ 
        height: '96px',
        borderRadius: '24px',
        paddingLeft: '8px',
        paddingRight: '16px',
        marginBottom: '10px'
      }}
    >
      <Typography sx={{ fontSize: '64px' }} className="font-medium">
        {order.orderShortId}
      </Typography>
      {order?.merchantImageUrl && (
        <img 
          src={order?.merchantImageUrl} 
          alt={order.outletName}
          style={{
            width: '70px',
            height: '70px',
            borderRadius: '16px',
            marginTop: '18px',
            marginBottom: '18px',
            marginLeft: 'auto',
            marginRight: '8px'
          }}
          className="object-contain"
        />
      )}
    </Box>
  );
};

const OrderQueueSidebar = ({ 
  atBaseOrders, 
  notAtBaseOrders 
}: OrderQueueSidebarProps) => {
  return (
    <Box 
      className="bg-gray-50 border-r border-mannamono-line overflow-y-auto h-full flex flex-col"
      sx={{ 
        width: '290px',
        paddingLeft: '12px',
        paddingRight: '12px',
        paddingTop: '32px',
        paddingBottom: '32px'
      }}
    >
      
      {/* At base section */}
      <Box sx={{ marginBottom: '10px' }}>
        <Typography variant="h5" className="font-medium text-2xl" sx={{ marginBottom: '10px' }}>
          At base
        </Typography>
        <Box>
          {atBaseOrders.length > 0 ? (
            atBaseOrders.map(order => (
              <OrderQueueCard key={order.id} order={order} />
            ))
          ) : (
            <Typography className="text-gray-400 text-lg">
              No orders at base
            </Typography>
          )}
        </Box>
      </Box>

      {/* Not at base section */}
      <Box>
        <Typography variant="h5" className="font-medium text-2xl" sx={{ marginBottom: '10px' }}>
          Arriving soon ({notAtBaseOrders.length})
        </Typography>
        <Box>
          {notAtBaseOrders.length > 0 ? (
            notAtBaseOrders.map(order => (
              <OrderQueueCard key={order.id} order={order} />
            ))
          ) : (
            <Typography className="text-gray-400 text-lg">
              No orders incoming
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default OrderQueueSidebar;

